<div class="chart">
  <canvas
    baseChart
    [type]="'bar'"
    [options]="CHART_OPTIONS"
    [datasets]="datasets"
    [legend]="false"
  ></canvas>
</div>
<prlw-delivery-time-graph-tooltip
  [data]="tooltipData"
  [displayParams]="tooltipDisplayParams"
>
</prlw-delivery-time-graph-tooltip>
